// Definition ID: def:rosta:ledger:paymentprovider
// Generic payment provider abstraction — enables swapping providers (StreetWallet,
// PayGate, SnapScan, etc.) without changing host UI code.

export type PaymentStatus = 'success' | 'failed' | 'cancelled';

export interface PaymentRequest {
  /** Unique transaction reference. Provider may require uniqueness to avoid blocking. */
  reference: string;
  /** Amount in ZAR. */
  amount: number;
  /** Optional human label shown in the UI / passed through to the provider. */
  description?: string;
}

export interface PaymentResult {
  status: PaymentStatus;
  reference: string;
  amount: number;
  /** Optional raw payload from the provider (e.g. postMessage data). */
  raw?: unknown;
}

export interface PaymentProvider {
  readonly id: string;
  /** Launch the payment flow and resolve with the outcome. */
  pay(request: PaymentRequest): Promise<PaymentResult>;
}

/** Generate a sufficiently unique reference for demo/test flows. */
export function generateReference(prefix = 'bp'): string {
  const rand = Math.random().toString(36).slice(2, 10);
  const time = Date.now().toString(36);
  return `${prefix}-${time}-${rand}`;
}
